import './accordion.scss';

class Accordion {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-accordion',
            elementAttr: 'element',
            triggerAttr: 'trigger',
            contentAttr: 'content',
            activeClassname: 'accordion__element--is-active',
            toggle: true
        };

        this.settings = Object.assign({}, settings, options);

        this.$accordion = element;
        this.$accordionElements = this.$accordion.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.elementAttr + '"]');

        this.triggerEvent = (e) => {
            const $trigger = e.target.closest('[' + this.settings.initAttr + '="' + this.settings.triggerAttr + '"]');
            if ($trigger) {
                const $element = $trigger.closest('[' + this.settings.initAttr + '="' + this.settings.elementAttr + '"]');
                if (this.settings.toggle === true) {
                    this.toggleContent($element);
                } else {
                    this.setActiveContent($element);
                }
            }
        };
    }

    init () {
        this.setEvents(true);
    }

    setEvents (active) {
        if (active === true) {
            this.$accordionElements.forEach((element) => {
                element.firstElementChild.addEventListener('keydown', (e) => {
                    if (e.code === 'Space' || e.code === 'Enter') {
                        e.preventDefault();
                        this.toggleContent(element);
                    }
                });
            });
            this.$accordion.addEventListener('click', this.triggerEvent, false);
        } else {
            this.$accordion.removeEventListener('click', this.triggerEvent, false);
        }
    }

    toggleContent ($accordionElement) {
        if ($accordionElement.classList.contains(this.settings.activeClassname)) {
            this.closeContent($accordionElement);
        } else {
            this.openContent($accordionElement);
        }
    }

    setActiveContent ($accordionElement) {
        for (let i = 0; i < this.$accordionElements.length; i++) {
            const $currentElement = this.$accordionElements[i];

            if ($currentElement !== $accordionElement) {
                this.closeContent($currentElement);
            } else {
                this.toggleContent($accordionElement);
            }
        }
    }

    openContent ($accordionElement) {
        const $content = $accordionElement.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        const $trigger = $accordionElement.querySelector('[' + this.settings.initAttr + '="' + this.settings.triggerAttr + '"]');

        if ($content && $trigger) {
            $accordionElement.classList.add(this.settings.activeClassname);
            this.handleAriaStates($trigger, $content, true);
        }
    }

    closeContent ($accordionElement) {
        const $content = $accordionElement.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        const $trigger = $accordionElement.querySelector('[' + this.settings.initAttr + '="' + this.settings.triggerAttr + '"]');

        if ($content && $trigger) {
            $accordionElement.classList.remove(this.settings.activeClassname);
            this.handleAriaStates($trigger, $content, false);
        }
    }

    handleAriaStates ($trigger, $content, state) {
        $trigger.setAttribute('aria-selected', state);
        $trigger.setAttribute('aria-expanded', state);
        $content.setAttribute('aria-hidden', !state);
    }

    destroy () {
        this.setEvents(false);
    }
}

export { Accordion };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$accordion = $context.querySelectorAll('[data-accordion="root"]');

        for (let i = 0; i < $$accordion.length; i++) {
            const $accordion = $$accordion[i];

            const accordion = new Accordion($accordion);
            accordion.init();
        }
    }
});
